import { jsx as _jsx } from "react/jsx-runtime";
import './index.css';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { NLS_LOAD_PATH, SERVICES } from 'consts';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Wrapper } from 'shared-components/wrapper';
const container = document.getElementById('root');
const root = createRoot(container);
SERVICES.axiosService.axiosInstance.interceptors.request.use(async (config)=>{
    if (config.url !== refreshTokenUrl) {
        config.headers.authorization = `Bearer ${SERVICES.cookiesService.get('access')}`;
        config.headers['Accept-Language'] = SERVICES.languageService.currentLanguage.toLocaleUpperCase();
    }
    return config;
}, (error)=>{
    Promise.reject(error);
});
const refreshTokenUrl = `auth/v1/auth/token`;
const cookieOptions = {
    httpOnly: false
};
const refreshAuthLogic = ()=>{
    return SERVICES.axiosService.axiosInstance.post(refreshTokenUrl, {}, {
        headers: {
            Authorization: `Bearer ${SERVICES.cookiesService.get('refresh')}`
        },
        skipAuthRefresh: true
    }).then((response)=>{
        SERVICES.cookiesService.set('access', response.data.accessToken, cookieOptions);
        SERVICES.cookiesService.set('refresh', response.data.refreshToken, cookieOptions);
        return Promise.resolve();
    }).catch((err)=>{
        if (SERVICES.cookiesService.get('access') && SERVICES.cookiesService.get('refresh')) {
            SERVICES.cookiesService.remove('access');
            SERVICES.cookiesService.remove('access.sig');
            SERVICES.cookiesService.remove('refresh');
            SERVICES.cookiesService.remove('refresh.sig');
        }
        return Promise.reject(err);
    });
};
createAuthRefreshInterceptor(SERVICES.axiosService.axiosInstance, refreshAuthLogic, {
    retryInstance: SERVICES.axiosService.axiosInstance
});
SERVICES.axiosService.axiosInstance.interceptors.response.use((response)=>{
    if (response.headers['csi-header-id']) {
        var _SERVICES_surveyService;
        SERVICES.surveyService.getShowSurveySetter(true);
        (_SERVICES_surveyService = SERVICES.surveyService) === null || _SERVICES_surveyService === void 0 ? void 0 : _SERVICES_surveyService.getCsiIdSetter(response.headers['csi-header-id']);
    }
    return response;
}, function(error) {
    var _error_response;
    if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 401 && error.config.url === refreshTokenUrl && !location.pathname.includes('trade-platform')) {
        if (SERVICES.cookiesService.get('access') && SERVICES.cookiesService.get('refresh')) {
            SERVICES.cookiesService.remove('access');
            SERVICES.cookiesService.remove('access.sig');
            SERVICES.cookiesService.remove('refresh');
            SERVICES.cookiesService.remove('refresh.sig');
        }
        localStorage.removeItem('videoCallOrderId');
        localStorage.removeItem('videoCallType');
        localStorage.removeItem('promoCodeApi');
        localStorage.removeItem('isModalShowed');
        localStorage.removeItem('selectedCif');
        localStorage.removeItem('phoneNumber');
        localStorage.removeItem('asanId');
        localStorage.removeItem('verificationNumber');
        localStorage.removeItem('sessionIdForAsan');
        localStorage.removeItem('asan-mobile-number');
        sessionStorage.clear();
        const locale = SERVICES.cookiesService.get('lang') ?? 'az';
        window.location.href = `/login/${locale}?redirect=${window.location.pathname}${window.location.search}`;
        return;
    }
    return Promise.reject(error.response);
});
SERVICES.i18nService.i18nInstance.use(initReactI18next).use(Backend).use(LanguageDetector).init({
    backend: {
        loadPath: (_, param)=>{
            let [nls] = param;
            return NLS_LOAD_PATH[`${nls}`] ?? '/locales/{{lng}}/{{ns}}.json';
        },
        requestOptions: {
            cache: 'no-store'
        }
    },
    ns: [],
    defaultNS: 'common',
    supportedLngs: [
        'az',
        'en',
        'ru'
    ],
    fallbackLng: 'az',
    interpolation: {
        escapeValue: false,
        formatSeparator: ','
    },
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '-',
    detection: {
        htmlTag: document.documentElement,
        lookupCookie: 'lang',
        lookupLocalStorage: 'lang',
        cookieMinutes: 525949,
        order: [
            'cookie',
            'localStorage'
        ],
        caches: [
            'cookie',
            'localStorage'
        ]
    }
}, ()=>{
    root.render(/*#__PURE__*/ _jsx(BrowserRouter, {
        children: /*#__PURE__*/ _jsx(Wrapper, {})
    }));
});
